export default "__VITE_ASSET__DAv8r7wN__$_?nuxt_component=async&nuxt_component_name=IconFrameShapeHalb&nuxt_component_export=default__"